import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import {
  Alert,
  Grid,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Page,
  Typography
} from '../../../components/v2/styled';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

import HelpersPractice from '../../../actions/helpers/practice';
import { MollieLink } from '../../../models/MollieLink';
import { CoachMollieLinkCreate } from '../../../components/v2/dialogs/CoachMollieLinkCreate';
import ContentCopy from '@mui/icons-material/ContentCopy';
import PersonSearch from '@mui/icons-material/PersonSearch';
const { DateTime } = require("luxon");

type Props = {}

export const CoachMollieLinksMollieLinks: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("created_at DESC");
  const [search, setSearch] = useState<string>("");

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);
  const [createOpen, setCreateOpen] = useState<boolean>(false);

  const [filterPaid, setFilterPaid] = useState<string>();

  const is_payments = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'payments'});

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "mollie_links", (login?.practice_id || currentPractice?.id), {page: page, order: order, search: search, filterPaid: filterPaid}],
    queryFn: () =>
      fetch_all_with_count<MollieLink>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'mollie_link',
          fields: ['id', 'description', 'amount', 'paid', 'extra_data', 'enabled', 'linked_item', 'linked_item_type', 'linked_item_id', 'user'],
          sub_fields: {
            linked_item: ['id', 'user', 'full_name'],
            user: ['id', 'full_name']
          },
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              paid: filterPaid
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id),
  });







  // const mutationDestroy = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<KnowledgeCourse>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     setDestroyedOpen(true);
  //     objectsRefetch();
  //   },
  // });








  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'description', headerName: t("coach.models.mollie_links.description"), width: 450 },
    { field: 'amount', headerName: t("coach.models.mollie_links.sub_count"), width: 120, align: 'right', renderCell: params => <>
      <Typography variant="caption">{params.row.amount} EUR</Typography>
    </> },
    { field: 'expiry', headerName: t("coach.models.mollie_links.expiry"), width: 200, renderCell: params => <>
      {!params.row.paid && !!params.row.extra_data?.expiry && <Typography variant="caption">{DateTime.fromISO(params.row.extra_data?.expiry).toFormat("dd/LL/y t")}</Typography>}
    </> },
    { field: 'paid', headerName: t('coach.models.mollie_links.paid'), width: 120, sortable: false, renderCell: params => <>
      {!!params.row.paid && <Check color='primary' sx={{marginBottom: -0.75}} />}
      {!params.row.paid && <Close color='secondary' sx={{marginBottom: -0.75}} />}
    </> },
    { field: 'paid_at', headerName: t("coach.models.mollie_links.paid_at"), width: 200, renderCell: params => <>
      {!!params.row.paid && !!params.row.paid_at && <Typography variant="caption">{DateTime.fromISO(params.row.paid_at).toFormat("dd/LL/y t")}</Typography>}
    </> },
    { field: 'client', headerName: t('coach.models.mollie_links.client'), width: 200, sortable: false, renderCell: params => <>
      {!!params.row.linked_item?.user?.id && <Typography variant="caption">{params.row.linked_item?.user?.full_name} <PersonSearch sx={{
        cursor: 'pointer',
        marginBottom: -0.75,
        marginLeft: 1
      }} color="primary" onClick={() => {
        navigate(`/user/${params.row.linked_item?.user?.id}/detail`);
      }} /></Typography>}
      {params.row.linked_item_type === "User" && <Typography variant="caption">{params.row.linked_item?.full_name} <PersonSearch sx={{
        cursor: 'pointer',
        marginBottom: -0.75,
        marginLeft: 1
      }} color="primary" onClick={() => {
        navigate(`/user/${params.row.linked_item?.id}/detail`);
      }} /></Typography>}
      {params.row.linked_item_type === "Order" && <Typography variant="caption">Order#{params.row.linked_item_id}{!!params.row.user?.id && ` (${params.row.user.full_name})`} {!!params.row.user?.id && <PersonSearch sx={{
        cursor: 'pointer',
        marginBottom: -0.75,
        marginLeft: 1
      }} color="primary" onClick={() => {
        navigate(`/user/${params.row.user?.id}/detail`);
      }} />}</Typography>}
    </> },
  ];

  return <Page title={t("coach.menu.mollie_links")} premiumGatekeeping={!!is_payments} premiumMode='payments'>
    {!currentPractice?.settings?.mollie_api_key && <Grid item xs={12}>
      <Alert severity='info'>
        <Typography>{t("coach.models.mollie_links.warning.no_mollie_set_up")}</Typography>
      </Alert>
    </Grid>}

    <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
      activeTag2={filterPaid}
      setActiveTag2={setFilterPaid}
      tags2={[
        {id: '0', name: t("coach.models.mollie_links.fields.paid_status.unpaid")},
        {id: '1', name: t("coach.models.mollie_links.fields.paid_status.paid")}
      ]}
    />

    <DataGrid
      action_count={1}
      hideCount
      actions={(params) => {
        return (<>
          {!params.row.paid && !!params.row.extra_data?.mollie?.payment_link && <IconButton title="Link" color="default" onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(params.row.extra_data?.mollie?.payment_link);
          }}>
            <ContentCopy />
          </IconButton>}
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        paid_at: u.extra_data?.mollie?.paid_at
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />

    <Fab
      onClick={() => {
        setCreateOpen(true);
      }}
    />

    <CoachMollieLinkCreate
      open={createOpen}
      setOpen={setCreateOpen}
      onClose={() => {

      }}
      refetch={objectsRefetch}
    />
  </Page>;
}
